























































































































































import { Component, Vue } from 'vue-property-decorator';
import TasksListTable from '@/components/UserTasks/TasksListTable.vue';
import ActionLogsTable from '@/components/UserDetails/ActionLogsTable.vue';
import TicketsListTable from '@/components/Tickets/TicketsListTable.vue';
import WriteThroughChatbot from '@/components/UserDetails/Modals/WriteThroughChatbot.vue';
import { readStructureUserDetails, readUserProfile } from '@/store/main/getters';
import MdIcon from '@/components/vui-luma/Ui/MdIcon.vue';
import {FmvAvatar} from 'fmv-avatar';
import { dispatchGetStructureUserDetails } from '@/store/main/actions';
import { api } from '@/api';

@Component({
  components: {
    MdIcon,
    FmvAvatar,
    TasksListTable,
    ActionLogsTable,
    TicketsListTable,
    WriteThroughChatbot,
  },
})
export default class ViewUserDetails extends Vue {

  public loadingState = {
    details: false,
    submit: false,
  };
  public writeTelegramModal = false;

  public async mounted() {
    this.loadingState.details = true;
    await dispatchGetStructureUserDetails(this.$store, {user_id: Number(this.$router.currentRoute.params.pk)});
    this.loadingState.details = false;
  }
  get userProfile() {
    return readUserProfile(this.$store);
  }
  get userDetails() {
    return readStructureUserDetails(this.$store);
  }
  public async handleWriteInTG() {
    if (this.userDetails && this.userDetails.tg_username) {
      window.open(`https://t.me/${this.userDetails.tg_username}`, '_blank');
    } else {
      this.writeTelegramModal = true;
    }
  }
  public handleCloseTelegramModal() {
    this.writeTelegramModal = false;
  }
  public async getResetCredsTokenForUser() {
    if (this.userDetails) {
      try {
        const response = await api.getResetCredsTokenForUser(
          this.$store.getters.token, Number(this.$router.currentRoute.params.pk),
        );
        this.$copyText(response.data.reset_link_token).then((e) => {
          // @ts-ignore
          this.showToast(this, this.$t('Link created and copied successfully. Expires in one hour'));
        }, (e) => {
          // @ts-ignore
          this.showToast(this, this.$t('Error, unable to copy'), 'error');
        });
      } catch (e) {
        // @ts-ignore
        this.showToast(this, this.$t('Error'), 'error');
      }
    }
  }
}
